module.exports = __webpack_public_path__ + "img/menu-w.54f9ac8b.svg";